import React, { useEffect, useMemo, useState,useRef } from "react";
import BioIconSVG from "assets/svg/bio-icon";
import Button from "components/button/button";
import CalendarDayIconSVG from "assets/svg/calendar-day-icon";
import MapMarkerIconSVG from "assets/svg/map-marker-icon";
import TagIconSVG from "assets/svg/tag-icon";
import ChildHeadIconSVG from "assets/svg/child-head-icon";
import IDBadgeIconSVG from "assets/svg/id-badge-icon";
import HairIconSVG from "assets/svg/hair-icon";
import HeightIconSVG from "assets/svg/height-icon";
import { HiOutlinePencil } from "react-icons/hi";
import { FiCheck } from "react-icons/fi";
import TextArea from "components/textarea/textarea";
import toast from "react-hot-toast";
import LoadingIndicator from "assets/svg/loading-indicator";
import Input from "components/input/input";
import InputCm from "components/input/input-cm";
import { removeUndefinedProperties } from "utils/utils";
import _ from "lodash";
import Select from "components/select/select";
import DatePicker from "components/datepicker/datepicker";
import moment from "moment";
import PopInfo from "components/info-popup/pop-info";
import { personalDateFormat,currentLang, get_age, cleanHtml, parseDateOnly } from "utils/utils";
import LanguagePicker from "components/language-picker";
import TranslateIcon from "assets/svg/translate-icon.svg";
import Flag from "react-world-flags";
import { useLanguages } from "redux/modules/languages/hook";
import CustomCheckbox from "components/checkbox/custom-checkbox";
// import { age_setup } from "utils/constant";
import MultiRangeSlider from "components/multiRange/MultiRangeSlider";
import { IoEllipse } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { GoPerson } from "react-icons/go";
import Popup from "reactjs-popup";
import { FaEllipsisH  } from "react-icons/fa";
import { IoLanguageOutline } from "react-icons/io5";
import AutoCompleteAddress from "components/google-address/auto-complete";
import WYSIWYGEditor from "components/wysiwyg/wysiwyg";

const ICONS = {
  birthdate: <CalendarDayIconSVG className="m-auto" />,
  birth_location: <MapMarkerIconSVG className="m-auto" />,
  birth_name: <GoPerson size={24} className="m-auto" />,
  civil_status: <TagIconSVG className="m-auto" />,
  children: <ChildHeadIconSVG className="m-auto" />,
  height: <HeightIconSVG className="m-auto" />,
  hair_color: <HairIconSVG className="m-auto" />,
  other_name: <IDBadgeIconSVG className="m-auto" />,
  languages: <TranslateIcon className="m-auto"/> 
};

/**
 * 
 * @param {Array<any>} languages 
 */
const parseLanguage = (languages,t) => {
  return languages?.map(item => ({
    lang_id: item.id,
    level: t(item.level),
    level_id: item.level_id,
    country: item.country,
    countryCode: item.countryCode,
    shortName: item.shortName,
    name: item?.[currentLang()] || item.name,
    orderNumber: item.orderNumber
  })) || [];
};

export default function PersonalInformation(props) {
  const {t} = useTranslation();

  const CIVIL_STATUS = [
    { label: t("Married"), value: "Married" },
    { label: t("Widowed"), value: "Widowed" },
    { label: t("Separated"), value: "Separated" },
    { label: t("Divorced"), value: "Divorced" },
    { label: t("Single"), value: "Single" },
  ];

  const CHILD = [
    { label: t("0Children"), value: 0 },
    { label: t("1Children"), value: 1 },
    { label: t("2Children"), value: 2 },
    { label: t("3Children"), value: 3 },
    { label: t("4Children"), value: 4 },
    { label: t("5Children"), value: 5 },
    { label: t("6Children"), value: 6 },
    { label: t("7Children"), value: 7 },
    { label: t("8Children"), value: 8 },
    { label: t("9Children"), value: 9 },
    { label: t("10Children"), value: 10 },
  ];

  const buttonProps = {
    edit: {
      btnName: t("edit"),
      icon: <HiOutlinePencil />,
      btnClass: "relative px-6 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full",
      btnTextClass:
        "text-lg  flex flex-row items-center gap-2",
    },
    save: {
      btnName: t("saveChanges"),
      icon: <FiCheck className="text-lg" />,
      btnClass: "relative py-3.6 px-5.5 bg-primary hover:bg-darkPrimary",
      btnTextClass:
        "text-sm text-white font-semibold flex items-center space-x-1.6",
    },
  };

  const age_setup = [
    {
      id:1,
      label: t("showBirthdayage"),
      value:null,
      bday:''
    },
    {
      id:6,
      label:t('birthday'),
      value:'',
      bday:''
    },
    {
      id:2,
      label: t("justShowAge"),
      value:null,
      bday:''
    },
    {
      id:3,
      label: t('Show7Years'),
      value:null,
      bday:''
    },
    {
      id:4,
      label:t('freeText'),
      value:'',
      bday:''
    },
    {
      id:5,
      label: t("hide"),
      value:false,
      bday:''
    }
  ];

  const { profile, userData, setUserData } = props;
  const { http, localstorage } = global.services;
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    bio: profile?.bio,
    birthdate: profile?.birthdate ? parseDateOnly(profile?.birthdate) : null,
    birth_location: profile?.birth_location,
    birth_name: profile?.birth_name || "",
    civil_status: profile?.civil_status,
    children: profile?.children,
    other_name: profile?.other_name,
    languages: parseLanguage(profile?.languages,t)
  });
  const [personal, setPersonal] = useState([]);
  const { languages } = useLanguages();
  const [showMoreOption, setShowMoreOption] = useState();
  const optionRef = useRef();
  const [loadingTranslate , setTransLoad] = useState(false);
  const lang = currentLang();
  const [errorMessages, setErrorMessages] = useState({});
  const preEditState = useRef(null);

  useEffect(() => {
    // Snapshot the values when entering edit mode so Cancel can revert them.
    if (edit) preEditState.current = state;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [edit]);

  const onClickCancel = () => {
    if (preEditState.current) {
      setState(preEditState.current);
    }
    setErrorMessages({});
    setEdit(false);
  };

  useEffect(() => {
    console.log('profile: ', profile);
    // profile.dateFormat  
    let labelAge = age_setup.find(item => item?.id === profile?.age_setup?.id)?.label;
    if ([t("justShowAge"), t("freeText"), t("hide")].includes(labelAge)) {
      labelAge = t("justShowAge");
    }
    if (!_.isEmpty(profile)) {
      let description = profile.bio;
        if (!_.isEmpty(profile.mention_bio)) {
          Object.keys(profile.mention_bio).forEach((k) => {
            const pUsername = profile.mention_bio[k]?.p_username;
            // Regex to match href containing username and capture the name between <a> and </a>
            const regex = new RegExp(`(<a[^>]*key="[^"]*${pUsername}[^"]*"[^>]*>)(.*?)(<\/a>)`, 'g');
            
            description = description.replace(regex, (match, openingTag, name, closingTag) => {
              return `${openingTag}@${pUsername}${closingTag}`;
            });
          });
        }
      setState({
        bio: description,
        birthdate:  profile?.birthdate ? parseDateOnly(profile?.birthdate) : null,
        birth_location: profile?.birth_location,
        birth_name: profile?.birth_name || "",
        civil_status: profile?.civil_status,
        children: profile?.children,
        other_name: profile?.other_name,
        languages: parseLanguage(profile?.languages,t),
        age_setup:profile?.age_setup || null
      });
      setPersonal([
        [
          {
            label: t('dateBirth'),
            placeholder: profile?.birthdate ? t('dateBirth') : " ",
            value: profile?.birthdate,
            icon: ICONS.birthdate,
            form: "datepicker",
            formProps: {
              name: "birthdate",
            },
            age_setup:{...profile.age_setup,
            label: labelAge,
            }
          },
          {
            label: t('birthLocation'),
            value: profile?.birth_location,
            icon: ICONS.birth_location,
            form: "address",
            formProps: {
              name: "birth_location",
            },
          },
        ],
        [
          {
            label: t('birthName'),
            value: profile?.birth_name,
            icon: ICONS.birth_name,
            form: "input",
            formProps: {
              name: "birth_name",
            },
          }
        ],
        [
          {
            isClearable: true,
            label: t("civilStatus"),
            value: profile?.civil_status,
            icon: ICONS.civil_status,
            form: "select",
            formProps: {
              name: "civil_status",
            },
          },
          {
            isClearable: true,
            label: t("children"),
            value: profile?.children || null,
            icon: ICONS.children,
            form: "select",
            formProps: {
              name: "children",
            },
          },
        ],
        [
          {
            label: profile?.dateFormat ? t('heightCm') : t('heightFt'),
            unit : profile?.dateFormat  ? t('cm') : t('ft'),
            value: profile?.height,
            icon: ICONS.height,
            form: "input_cm",
            formProps: {
              name: "height",
            },
          },
          {
            label: profile?.lang=="en"&&profile?.dateFormat?t("hairColour"): "Hair Color",
            value: profile?.hair_color,
            icon: ICONS.hair_color,
            form: "input",
            formProps: {
              name: "hair_color",
            },
          },
        ],
        [
          {
            label: t("languagesSpoken"),
            value: parseLanguage(profile?.languages,t),
            icon: ICONS.languages,
            form: "language-select",
            formProps: {
              name: "languages",
            },
            className: "md:col-span-2"
          },
        ]
        // [
        //   {
        //     label: "Other Name",
        //     value: profile?.other_name,
        //     icon: ICONS.other_name,
        //     form: "input",
        //     formProps: {
        //       name: "other_name",
        //     },
        //   },
        // ],
      ]);
    }
  }, [profile,lang]);

  useEffect(() => {
          window.addEventListener(
              "scroll",
              () => {  
                  if (optionRef.current) {
                      optionRef.current.close();
                  }
              },
              true
          );
          return () => {
              window.removeEventListener("scroll", () => {});
          };
          // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

  //=============================functions ======================================
  const handleInputChange = (e) => {
    console.log('handleInputChange:', e);
    const { name, value } = e?.target || e;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateLang = () => {
    const newErrors = {};

    (state.languages || []).forEach((item, index) => {
      if (!item.level || item.level.trim() === "") {
        newErrors[index] = {
          ...(newErrors[index] || {}),
          level: "Language level is required.",
        };
      }

      if (!item.lang_id) {
        newErrors[index] = {
          ...(newErrors[index] || {}),
          lang_id: "Language is required.",
        };
      }
    });

    setErrorMessages(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Please complete all required fields.");
      return false;
    }

    return true;
  };

  const onClickSave = async () => {
    try {
      // profile.dateFormat

      if (!validateLang()) return;
      setLoading(true);
      console.log(JSON.stringify(state, null, 2));
      const payload = removeUndefinedProperties(state);
      /**
       * this will allow civil_status, and children to be cleared
       */
      payload.civil_status = state?.civil_status || null;      
      payload.children = state?.children || 0; 
      payload.bio = cleanHtml(state?.bio || '')     

      if (!_.isEmpty(payload)) {
        if (payload.birthdate) {
          // Send the birthdate as a plain calendar date (local Y-M-D) so it is
          // stored exactly as picked. The previous "+8 hours" hack shifted the
          // day depending on the user's timezone/save time (off-by-one bug).
          payload.birthdate = moment(payload.birthdate).format("YYYY-MM-DD");
        }
        payload.age_setup = JSON.stringify(state?.age_setup);
        
        const { data } = await http.put(
          `public/profiles/update-personal-information/${profile?.id}`,
          payload
        );
        if (data) {
          toast.success(t('personalInformationSuccessfully'));
          updateProfile(data)
        }
      }
    } catch (error) {
      console.log(error)
      toast.error(
        error?.data?.message || t('somethingWentWrong')
      );
      setLoading(false);
      setEdit(false);
    } 
    // finally {
    //   setLoading(false);
    //   setEdit(false);
    // }
  };

    const updateProfile = (data)=>{  
      const resultValue = data.data;
      let labelAge = age_setup.find(item => item.id === resultValue?.age_setup?.id)?.label;
      if ([t("justShowAge"), t("freeText"), t("hide")].includes(labelAge)) {
        labelAge = t("justShowAge");
      }
      setPersonal([
        [
          {
            label: t('dateBirth'),
            placeholder: profile?.birthdate ? t('dateBirth') : "January 1 1970",
            value: resultValue.birthdate,
            icon: ICONS.birthdate,
            form: "datepicker",
            formProps: {
              name: "birthdate",
            },
            age_setup:{...profile.age_setup,
              label: labelAge,
            }
          },
          {
            label: t('birthLocation'),
            value: resultValue.birth_location,
            icon: ICONS.birth_location,
            form: "input",
            formProps: {
              name: "birth_location",
            },
          },
        ],
        [
          {
            label: t('birthName'),
            value: resultValue.birth_name,
            icon: ICONS.birth_name,
            form: "input",
            formProps: {
              name: "birth_name",
            },
          },
        ],
        [
          {
            label: t("civilStatus"),
            value: resultValue.civil_status,
            icon: ICONS.civil_status,
            form: "select",
            formProps: {
              name: "civil_status",
            },
          },
          {
            label:  t("children"),
            value: resultValue.children,
            icon: ICONS.children,
            form: "select",
            formProps: {
              name: "children",
            },
          },
        ],
        [
          {
            label: profile?.dateFormat ? t('heightCm') : t('heightFt'),
            unit : profile?.dateFormat ? "cm" : "ft",
            value: resultValue.height,
            icon: ICONS.height,
            form: "input_cm",
            formProps: {
              name: "height",
            },
          },
          {
            label: profile?.lang=="en"&&profile?.dateFormat?t("hairColour"): "Hair Color",
            value: resultValue.hair_color,
            icon: ICONS.hair_color,
            form: "input",
            formProps: {
              name: "hair_color",
            },
          },
        ],
        // [
        //   {
        //     label: "Other Name",
        //     value: resultValue.other_name,
        //     icon: ICONS.other_name,
        //     form: "input",
        //     formProps: {
        //       name: "other_name",
        //     },
        //   },
        // ],
      ]);
      //set userdata and update localstorange
      console.log("resultValue", resultValue);
      const updatedData = { ...userData, profile: {...profile,...resultValue} };
      setUserData(updatedData);
      localStorage.setItem("user_data", JSON.stringify(updatedData));
      typeof props.onDoneUpdate === 'function' && props.onDoneUpdate(updatedData);
      //update state to false
      setLoading(false);
      setEdit(false);
    }

  const displayValue = (name, value, obj) => {
    const dateFormat = !!profile?.dateFormat;
    // show height formatted depending on profile.dateFormat
    if (name === 'height') {
      if (!value && value !== 0) return "--";
      const cm = Number(value) || 0;
      if (profile?.dateFormat) {
        return `${cm} ${t('cm') || 'cm'}`;
      } else {
        const inchesTotal = Math.round(cm / 2.54);
        const feet = Math.floor(inchesTotal / 12);
        const inches = inchesTotal % 12;
        return `${feet} ${t('ft') || 'ft'} ${inches} ${t('in') || 'in'}`;
      }
    }
    if (name === "children") {
      if (value) {
        let res = CHILD.find(item => item.value === value)
        // return `${value} Children`;
        return res ? t(res?.label) : `${value} Children`;

      } else {
        return "--";
      }
    } else if (name === "birthdate") {
      if (value) {
        if(obj?.age_setup?.value){
          const {value,id,bday} = obj?.age_setup;
          const updatedVal = value.replace('years old', t('yearsOld'));
          if(id === 1){/**Bday only and age*/
            let lang = currentLang() === 'ch' ? 'zh-cn' : (currentLang() || 'en');
            return <span className="flex items-center gap-1">
              {/* {bday} <IoEllipse className="w-1 h-1" /> {value} */}
              {moment(bday).locale(lang).format(dateFormat ? 'D MMMM YYYY' : 'MMMM D YYYY')} <IoEllipse className="w-1 h-1" /> {`${get_age(profile?.birthdate)} ${t('yearsOld')}`}
            </span>;
          }else if(id === 2){/**Age only*/
            return <span className="flex items-center gap-1">
              {`${get_age(profile?.birthdate)} ${t('yearsOld')}`}
            </span>;
          }else if(id === 6){/**Bday only */
            return <span className="flex items-center gap-1">
              {moment(bday).locale(lang).format(dateFormat ? 'D MMMM' : 'MMMM D')}
            </span>;
          }
          return updatedVal || value;
        }
        return personalDateFormat(profile?.birthdate, profile?.dateFormat);
      } else {
        return "--";
      }
    }else if (name === 'civil_status'){
      if (value) {
        let res = CIVIL_STATUS.find(item => item.value === value)
        // return `${value} Children`;
        return res ? t(res?.label) : value;

      } else {
        return "--";
      }
    }else if(name === "birth_location"){
      return (profile?.translation?.[lang]?.[value] || value) || '--';
    } else {
      return value || "--";
    }
  };

   const handleBioChange = React.useCallback((val) => {
    setState(prev => {
      if (prev.bio === val) return prev;
      return { ...prev, bio: val };
    });
  }, []);

  const customClassNames = useMemo(() => {
    if (props.isYourProfile) {
      return "w-full flex flex-start items-start space-x-6";
    } else {
      if (profile?.bio) {
        return "w-full flex flex-start items-start space-x-6";
      } else {
        return "hidden";
      }
    }
  }, [props.isYourProfile, profile?.bio]);

  const translatePersonalInfo = async()=>{
    if (userData?.profile?.id === profile?.id) {
        try{
            setTransLoad(true)
            let curLang = localStorage.getItem('lang');
            const { data } = await http.put(`public/profile/${profile?.id}/translate-personal-info`,{
                lang:curLang
            }); 
            if(data.data){
                updateProfile(data)
                toast.success(t('completedTranslate'))
            }else{
                toast.success(t('beenTranslated'));
            }
            setTransLoad(false)
        }catch(e){
            setTransLoad(false)
            toast.error(t('somethingWentWrong'));
        }
    }
  }

  // Whether any "Other Information" field below the Bio actually renders (mirrors
  // the per-field render predicate). Used to hide the Bio divider when there is
  // no content beneath it.
  const hasOtherInfoContent = (personal?.flat() || []).some((obj) => {
    if (["string", "number"].includes(typeof obj?.value)) return true;
    if (Array.isArray(obj?.value)) return (obj?.value.length || 0) > 0;
    return false;
  });

  return (
    <div className="w-full bg-white rounded-md px-5 2md:pl-29 2md:pr-24.5 py-10 md:pb-14 md:pt-8">
      <div className="w-full flex justify-between flex-wrap items-center mb-8 ">
        <div className="flex flex-row gap-x-2 items-center">
          <h1 className="text-base 2sm:text-2xl font-semibold text-lightBlack">
            {profile?.profile_type?.type === 'character' ? "Character Information" : t('personalInformation')}
          </h1>
          <PopInfo containerClass="relative" type={profile?.profile_type?.type === 'character' ? "character_information" : "personal_information"} />
        </div>
        {props.isYourProfile && (
          <>
          {
            edit ?
            <div className="flex flex-row items-center gap-x-3.5">
              <Button
                buttonName={t("cancel")}
                buttonTextClass="text-sm text-lightBlack font-bold"
                buttonRadius="6px"
                buttonClass="relative py-3.6 px-5.5 bg-thBg hover:bg-gray"
                disabled={loading}
                onClick={onClickCancel}
              />
              <Button
                buttonName={buttonProps.save.btnName}
                buttonTextClass={buttonProps.save.btnTextClass}
                iconPosition="left"
                icon={buttonProps.save.icon}
                buttonRadius="6px"
                buttonClass={buttonProps.save.btnClass}
                loadingIcon={
                  loading ? (
                    <LoadingIndicator className="text-white w-4 h-4" />
                  ) : null
                }
                disabled={loading}
                onClick={onClickSave}
              />
            </div>
            :
              <Popup
                ref={optionRef}
                position="bottom right"
                open={showMoreOption}
                onClose={() => setShowMoreOption(false)}
                arrow={false}
                contentStyle={{ marginTop: 10, marginLeft: 5 }}
                trigger={
                    <button
                        className="py-0 bg-thBg rounded-md 3md:py-4 3md:px-5 px-3"
                        onClick={() =>
                            setShowMoreOption((open) => !open)
                        }
                    >
                        <FaEllipsisH className="p-0 m-0" />
                    </button>
                }
              >
                <div className="flex flex-col shadow-lg rounded-md bg-white">
                    <ul className="w-full">
                        <li className="hover:bg-gray hover:rounded-md">
                            <Button
                              buttonName={
                                edit ? buttonProps.save.btnName : buttonProps.edit.btnName
                              }
                              buttonTextClass={
                                edit
                                  ? buttonProps.save.btnTextClass
                                  : buttonProps.edit.btnTextClass
                              }
                              iconPosition="left"
                              icon={edit ? buttonProps.save.icon : buttonProps.edit.icon}
                              buttonRadius="6px"
                              buttonClass={
                                edit ? buttonProps.save.btnClass : buttonProps.edit.btnClass
                              }
                              loadingIcon={
                                loading ? (
                                  <LoadingIndicator className="text-white w-4 h-4" />
                                ) : null
                              }
                              disabled={loading}
                              onClick={() => {
                                if (edit) {
                                  onClickSave();
                                } else {
                                  setEdit((prev) => !prev);
                                }
                              }}
                            />
                        </li>
                        <li>
                            <Button
                                disabled={loadingTranslate}
                                buttonName={
                                    <div className="flex gap-2 items-center">
                                        <IoLanguageOutline/>
                                        <div>{t('translate')}</div>
                                    </div> 
                                }
                                buttonTextClass="text-lg  flex flex-row items-center gap-2"
                                buttonRadius="6px"
                                icon={
                                loadingTranslate ? (
                                    <LoadingIndicator className="text-primary w-4 h-4" />
                                ) : null
                                }
                                buttonClass="relative px-6 py-2 bg-white hover:bg-gray hover:rounded-b-md justify-start w-full"
                                onClick={translatePersonalInfo}
                            />
                        </li>                     
                    </ul>
                </div>
              </Popup> 
          }  
          </>
        )}
      </div>
      <div className="w-full grid gap-y-12 max-w-screen-2smd">
        {/* ==================== BIO =================================== */}
        {(profile?.bio || edit ) && (
          <>
            <div className="w-full">
              <div className={customClassNames}>
                <div className="w-15 h-15 rounded-full bg-bGray grid">
                  <BioIconSVG className="m-auto" />
                </div>
                <div style={{ width: "calc(100% - 60px)" }}> 
                  <div className="flex items-center">
                    <h3 className="text-base 2sm:text-xl text-lightBlack font-semibold">  {t('bio')}</h3>
                    {
                      edit &&
                      <>
                        <div className="h-3 w-px bg-gray-400 mx-2"></div>
                        <div className="italic font-light">
                          {t('writeInThePerson')}
                        </div>
                      </>
                    }
                  </div>
                  {edit ? (
                    <WYSIWYGEditor
                          optional={false}
                          value={state.bio}
                          limitChar={2000}
                          onChange={handleBioChange}
                          preserveWhitespace={true}
                          minimalToolBar={true}
                        />
                  ) : (
                    <p className="text-base leading-6.7 tracking-tightest text-darkerGray mt-1.5 whitespace-pre-line">
                      {/* {profile?.translation?.[lang]?.bio || profile?.bio || "--"} */}
                      <div dangerouslySetInnerHTML={{ __html: profile?.translation?.[lang]?.bio || profile?.bio || "--" }}>
                      </div>
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* ===================== Divider ============================================ */}
            {/* Only show the divider when there is content below it (or in edit mode). */}
            {(edit || hasOtherInfoContent) && <hr className="text-gray" />}
          </>
        )}
        {/* ==================== OTHER INFORMATION =================================== */}
        <div className="w-full">
          <div className="w-full grid gap-y-12">
            {/* {(personal || []).map((parent, index) => { */}
              {/* return ( */}
                <div
                  // className="w-full space-y-4.5 4sm:flex 4sm:flex-start 4sm:space-x-4.5 4sm:space-y-0"
                  className="w-full grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-12"
                  >
                  {(personal?.flat() || []).map(
                    (obj, subIndex) =>
                      (
                        ((() => {
                          if(['string' , 'number'].includes(typeof obj?.value)) {
                            return true;
                          }
      
                          if(Array.isArray(obj?.value)) {
                            if((obj?.value.length || 0) > 0) {
                              return true;
                            }
                          }
                         
                          return false;
                        })() || edit)
                      ) && (
                        <div
                          className={"w-full flex flex-start items-start space-x-6 " 
                            + (obj.className ? ` ${obj.className}` : "") 
                            + (edit && obj.form === "datepicker" ? " md:col-span-2 " : " ")
                            + (!edit && obj?.age_setup?.value === 'Hidden' ? "hidden " : " ") //hide when value of age is hide
                          }
                            
                          key={subIndex}>
                          <div className="w-15 h-15 rounded-full bg-bGray grid">
                            {obj.icon}
                          </div>
                          <div style={{ width: "calc(100% - 60px)" }}>
                            {obj?.form === "datepicker" ?  (
                              <h3 className="text-base 2sm:text-xl text-lightBlack font-semibold">
                                {!edit ? obj?.age_setup?.label : obj?.label || obj?.label }
                              </h3>
                            ): (
                              <h3 className="text-base 2sm:text-xl text-lightBlack font-semibold">
                                {obj?.label}
                              </h3>
                            )}
                            {edit ? (
                              <div className="w-full mt-3">
                                <FormBuilder
                                  type={obj.form}
                                  name={obj.formProps.name}
                                  placeholder={obj?.placeholder || obj.label}
                                  onChange={handleInputChange}
                                  isClearable={obj.isClearable}
                                  defaultValue={obj.value}
                                  state={state}
                                  USADateFormat={profile.dateFormat}
                                  age_setup={age_setup}
                                  t={t}
                                  CIVIL_STATUS={CIVIL_STATUS}
                                  CHILD={CHILD}
                                  profile={profile}
                                  errorMessages={errorMessages}
                                />
                              </div>
                            ) : (
                              Array.isArray(obj.value) ? (
                                <div className="flex flex-row flex-wrap justify-start gap-2 mt-3">
                                  {
                                    obj.value.filter(
                                        (item, index, self) =>
                                          index === self.findIndex(itm => itm?.name === item?.name)
                                      ).map((item, index) => {
                                      const hasDuplicates = () => {
                                        const langLength = languages.filter(
                                          (itm) => itm.name === item.name
                                        ).length;
                                
                                        return langLength > 1;
                                      };

                                      return (
                                        <div className="bg-[#F2F2F2] font-semibold text-sm py-2 px-3 rounded flex flex-row items-center gap-1" key={index}>
                                          {/* {!!item.countryCode && (
                                            <div>
                                              <Flag code={item.countryCode} height={16} width={16}/>
                                            </div>
                                          )} */}
                                          <div>{(item?.[lang] || item.name) + (hasDuplicates() ? ` ${item.shortName}` : '') } {`(${item.level})`}</div>
                                        </div>
                                      )
                                    })
                                  }

                                </div>
                              ) : (
                                <p className="text-base leading-6.7 tracking-tightest text-darkerGray mt-1.5">
                                  {displayValue(obj.formProps.name, obj.value, obj)}
                                </p>
                              )
                            )}
                          </div>
                        </div>
                      )
                  )}

                
                </div>
              {/* ); */}
            {/* })} */}
          </div>
        </div>
      </div>
    </div>
  );
}

function FormBuilder(props) {
  const { type, name, placeholder, onChange, defaultValue, state, USADateFormat,age_setup,t,CIVIL_STATUS,CHILD, isClearable,profile, errorMessages } = props;
  let options = CIVIL_STATUS;
  let selectDefaultValue = { label: defaultValue, value: defaultValue };
  const [selected, setSelected] = useState({...state?.age_setup} || {id:0,value:0});
  const [range, setRange] = useState({min:0, max:100});
  const [calAge,setCalAge] = useState(false);//calculate the age then show the age range

  const windowBounds = useMemo(() => {
  const base = Number.isFinite(range?.min) ? range.min : 0;
  const center = base + 7;
  return { lo: Math.max(0, center - 10), hi: center + 10 };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [calAge,range]);

  // helpers and hooks for height ft/in <-> cm conversions
  const isFt = !USADateFormat;
  const cmToFeetIn = (cm) => {
    if (cm === undefined || cm === null || cm === "") return { feet: "", inches: "" };
    const inchesTotal = Math.round(Number(cm) / 2.54);
    const feet = Math.floor(inchesTotal / 12);
    const inches = inchesTotal % 12;
    return { feet: String(feet), inches: String(inches) };
  };
  const feetInToCm = (feet, inches) => {
    const f = Number(feet) || 0;
    const i = Number(inches) || 0;
    const totalInches = f * 12 + i;
    const cm = Math.round(totalInches * 2.54);
    return cm;
  };

  const initialHeight = cmToFeetIn(defaultValue);
  const [feet, setFeet] = useState(initialHeight.feet);
  const [inches, setInches] = useState(initialHeight.inches);

  useEffect(() => {
    const init = cmToFeetIn(defaultValue);
    setFeet(init.feet);
    setInches(init.inches);
  }, [defaultValue]);

  useEffect(()=>{
    if(state?.age_setup?.id === 3 && name === 'birthdate'){
      let bday = state[name] ? new Date(state[name]) : null; 
      if(bday){
        const today = new Date();
        let age = today.getFullYear() - bday.getFullYear(); 
        const monthDifference = today.getMonth() - bday.getMonth();

        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < bday.getDate())) {
          age--;
        }
          let rangeMin = Math.abs(age - 7);
          let rangeMax = Math.abs(age + 7);
          setRange({min:rangeMin,max:rangeMax})
      }
      setCalAge(true)
    }
  },[state,name,setRange])

  const handleSelect = (option,value='', date) => {
    try {
      let age_setup = {...option};
      const initialBirthDate = date? date:state.birthdate;
      let dateFormat = initialBirthDate.toLocaleDateString('en-GB',{ 
        day: "numeric", 
        month: "long", 
        year: "numeric" });
      //if the user has toggle date format to usa
      if (USADateFormat) {
        dateFormat = initialBirthDate.toLocaleDateString('en-US', {
          month: "long",
          day: "numeric",
          year: "numeric"
        });
      } 
      const birthDate = new Date(initialBirthDate);
      // Get birthday without year, e.g. "December 4"
      const birthdayWithoutYear = birthDate.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric'
      });
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear(); 
      const monthDifference = today.getMonth() - birthDate.getMonth();

      // If the current month is before the birth month,
      // or it's the same month but the current day is before the birth day,
      // then subtract one from the age.
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      let rangeMin = Math.abs(age - 7);
      let rangeMax = Math.abs(age + 7);
      setRange({min:rangeMin,max:rangeMax})
      if(option.id === 1 || option.id === 2){ 
        age_setup = {...age_setup, bday: dateFormat, value:`${age} years old` }
          setSelected(age_setup);
      }else if(option.id === 3 || option.id === 4){
        if(option.id === 3){
          // value = `${rangeMin}-${rangeMax} years old`
          if(value){
            value = `${value}`
          }else{
            value = `${rangeMin}-${rangeMax} years old`
          }
        }
          age_setup = {...age_setup, bday: dateFormat, value:value }
          setSelected(age_setup);
      }
      else if(option.id ===6){
          age_setup = {...age_setup, bday: dateFormat, value: birthdayWithoutYear }
          setSelected(age_setup);
      }
      else{
          age_setup = {...age_setup, bday: dateFormat, value:'Hidden' }
          setSelected(age_setup);
      }
      setSelected(age_setup);
      onChange({name:"age_setup", value:age_setup})
    } catch (error) {
      
    }

  }

  const checkMaxMin = (e) => {
    let inputValue = e.target.value;
      
    if (inputValue !== undefined && inputValue.toString().length >= 3) {
      e.target.value = e.target.value.substring(0,3);
    }
    else if (inputValue < 0) {
      e.target.value = 0
    }
    onChange(e)
  };
  
  if (name === "children") {
    options = CHILD;
    let valueObject = _.find(CHILD, { value: defaultValue });
    selectDefaultValue = valueObject;
  }
  if (name === "civil_status") {
    selectDefaultValue = { label: t(defaultValue), value: defaultValue };
  }
  if (type === "input") {
    return (
      <Input
        inputContainerClass="w-full"
        defaultValue={defaultValue}
        name={name}
        placeholder={placeholder}
        outsideLabelClass="text-sm font-bold text-darkerGray"
        noLabelPaddingY="1rem"
        type="text"
        onChange={onChange}
      />
    );
  } else if (type === "input_cm") {
    // keep onFeetChange/onInchesChange logic declared here using outer hooks
    const onFeetChange = (e) => {
      let v = e?.target?.value;
      v = v === "" ? "" : String(parseInt(v, 10) || 0);
      setFeet(v);
      const cm = feetInToCm(v, inches);
      onChange({ target: { name: name, value: cm } });
    };

    const onInchesChange = (e) => {
      let v = e?.target?.value;
      v = v === "" ? "" : String(parseInt(v, 10) || 0);
      if (v !== "") {
        let vi = Number(v);
        if (vi < 0) vi = 0;
        if (vi > 11) vi = 11;
        v = String(vi);
      }
      setInches(v);
      const cm = feetInToCm(feet, v);
      onChange({ target: { name: name, value: cm } });
    };

    if (isFt) {
      return (
        <div className="w-full flex gap-3">
          <div className="w-1/2 relative">
            <Input
              inputContainerClass="w-full"
              value={feet}
              name={`${name}_feet`}
              placeholder={t('ft') || 'ft'}
              outsideLabelClass="text-sm font-bold text-darkerGray"
              noLabelPaddingY="1rem"
              type="number"
              disableUpDownArrow={true}
              onChange={onFeetChange}
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-darkerGray">{t('ft') || 'ft'}</span>
          </div>
          <div className="w-1/2 relative">
            <Input
              inputContainerClass="w-full"
              value={inches}
              name={`${name}_inches`}
              placeholder={t('in') || 'in'}
              outsideLabelClass="text-sm font-bold text-darkerGray"
              noLabelPaddingY="1rem"
              type="number"
              disableUpDownArrow={true}
              onChange={onInchesChange}
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-darkerGray">{t('in') || 'in'}</span>
          </div>
        </div>
      );
    }

    // default: single cm input
    return (
      <InputCm
        inputContainerClass="w-full"
        defaultValue={defaultValue}
        name={name}
        disableUpDownArrow={true}
        placeholder={placeholder}
        outsideLabelClass="text-sm font-bold text-darkerGray"
        noLabelPaddingY="1rem"
        type="number"
        onChange={checkMaxMin}
        USADateFormat={USADateFormat}
      />
    );
  } else if (type === "select") {
    return (
      <Select
        isClearable={isClearable}
        formContainer="w-full"
        options={options}
        placeholder={placeholder}
        name={name}
        defaultValue={selectDefaultValue || null}
        height={58}
        onChange={(e) => onChange({ target: { name: name, value: e?.value } })}
      />
    );
  } else if (type === "datepicker") {
    return (
      <div>
        <DatePicker
          profile={profile}
          formContainer="w-full"
          icon="noLabel"
          selected={state[name] ? new Date(state[name]) : null}
          onChange={(date) => {
            onChange({ target: { name: name, value: date ? new Date(date) : null } });
            if([0,1,2,3,4,6].includes(selected.id)){ // consider to use the id inside of the function
              handleSelect(selected, "", date ? new Date(date) : null);
            }
          }
            
          }
          placeholderText={placeholder}
        />
        <div className="mt-3">
          <div className="font-bold">
            {t('age')}
          </div>
          <p className="text-xs mt-1 text-[#777777]">{t('ageInstruction')}</p>
          <div className="grid grid-cols-1 md:grid-cols-6 mt-2 gap-2">
            {
              age_setup.map(option => 
                <CustomCheckbox 
                  key={option.id}
                  containerStyle="flex items-center"
                  label={
                    <p className="text-xs ml-0">
                      {option.label}
                    </p>
                  }
                  name={"age"}
                  checked={option.id === selected.id}
                  onChange={() => handleSelect(option)}
                  v2={true}
                />  
              )
            }
          </div>
           {
            selected.id === 3 && 
              <div className="relative mt-[35px]">
                {
                  calAge && 
                  <MultiRangeSlider 
                  key={`${windowBounds.lo}-${windowBounds.hi}`}
                  min={windowBounds.lo}
                  minLimit={windowBounds.lo}
                  max={windowBounds.hi}
                  limit={14} 
                  initVal={range} 
                  // disableRange={false}
                  labelAlign="end"
                  label={t('yearsOld')}
                  onChange={({min,max})=>{
                    handleSelect(selected, `${min}-${max} ${t('yearsOld')}`)
                  }}
                    />
                }
              </div>
           }
           {
            selected.id === 4 && 
            <Input
              required
              inputContainerClass="w-full mt-3"
              defaultValue={selected.value} 
              placeholder={"Free Text"}
              outsideLabelClass="text-sm font-bold text-darkerGray"
              noLabelPaddingY="1rem"
              type="text"
              onChange={(e)=>{ handleSelect(selected, e.target.value)
            }}
            />
           }
        </div>
      </div>
    );
  } else if (type === "language-select") {
    return <LanguagePicker onChange={data => onChange({ target: { name: "languages", value: data } })} state={state["languages"]} errorMessages={errorMessages}/>
  }else if (type === "address"){
    return <AutoCompleteAddress
      key={1}
      name="birth_location"
      value={state?.birth_location}
      onChange={(name,value) => onChange({ target: { name: name, value: value } })}
      placeholder="Melbourne VIC, Australia"
      errorMessage={state.validationErrors?.location}
      placeTypes={[]}
    />
  }
  return <></>;
}
